import { SAVE_EMAIL_FAILURE,SAVE_EMAIL_SUCCESS,STOP_LOADING,START_LOADING,UPDATE_EMAIL_FAILURE,UPDATE_EMAIL_SUCCESS,DELETE_EMAIL_FAILURE,DELETE_EMAIL_SUCCESS,
    GET_EMAIL_FAILURE,GET_EMAIL_SUCCESS,SAVE_SMS_SUCCESS,SAVE_SMS_FAILURE,GET_SMS_SUCCESS,GET_SMS_FAILURE,DELETE_SMS_SUCCESS,DELETE_SMS_FAILURE,SEARCH_EMAIL_SUCCESS,SEARCH_EMAIL_FAILURE,SEARCH_SMS_SUCCESS,SEARCH_SMS_FAILURE,
UPDATE_SMS_SUCCESS,UPDATE_SMS_FAILURE,GET_PHONE_FAILURE,GET_PHONE_SUCCESS,SEARCH_PHONE_SUCCESS,SEARCH_PHONE_FAILURE, GET_SMS_TEMPLATES_SUCCESS,GET_SMS_TEMPLATES_FAILURE} from "./actionTypes";
  import { saveEmail,updateEmail,getAllEmail,deleteEmailById, saveSMS,updateSMS,
    getAllSMS,deleteSmsById, searchSMS,getAllPhones,searchPhone,searchCommunication,
    getAllChatUserListService,
    sendMessage, getMessageSearchServices, getTotalMessageCountServices, getSelectedUserChatService, getUserCountService, getUnreadCountService,
    getAllSmsTemplates,
  sendEmailServices} from "../../services/communicationServices";
  import { openSessionTimeoutModal } from './sessionTimeOutActions';


  export const saveEmailAction = (formData, callbackfn) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'SAVE_EMAIL' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await saveEmail(formData, token);

        dispatch({ type: STOP_LOADING, service: 'SAVE_EMAIL' });
        if (response) {
          callbackfn(response);
        }
        dispatch({ type: SAVE_EMAIL_SUCCESS, payload: response }); // Dispatch the success action with response data
      } catch (error) {
        if (error?.includes("403")) {
          dispatch(openSessionTimeoutModal());
        } else {
          dispatch({ type: STOP_LOADING, service: 'SAVE_EMAIL' });
          dispatch({ type: SAVE_EMAIL_FAILURE, payload: error || 'Save email service failed. Please try again.' });
        }
      }
    };

    export const updateEmailAction = (formData,callbackfn) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'UPDATE_EMAIL' });
        const token = getState().auth.token || sessionStorage.getItem("token");;
        const response = await updateEmail(formData, token);
        dispatch({ type: STOP_LOADING, service: 'UPDATE_EMAIL' });
        if (response) {
          callbackfn(response);
        }
        dispatch({ type: UPDATE_EMAIL_SUCCESS, payload: response });
      } catch (error) {

        if(error?.includes("403")) {
          dispatch(openSessionTimeoutModal());
        } else {
          dispatch({ type: STOP_LOADING, service: 'UPDATE_EMAIL' });
          dispatch({ type: UPDATE_EMAIL_FAILURE, payload: error || 'Update email service failed. Please try again.' });
        }
      }
    };

    export const getAllEmailAction= (page = 0, size = 5) => async (dispatch, getState) => {

      try {
        dispatch({ type: START_LOADING, service: 'ALL_EMAIL' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getAllEmail(token, page, size);

        dispatch({ type: STOP_LOADING, service: 'ALL_EMAIL' });
        dispatch({ type: GET_EMAIL_SUCCESS, payload: response });
      } catch (error) {
        if(error?.includes("403")) {
          dispatch(openSessionTimeoutModal());
        } else {
          dispatch({ type: STOP_LOADING, service: 'ALL_EMAIL' });
          dispatch({ type: GET_EMAIL_FAILURE, payload: error || 'All task service failed. Please try again.' });
        }
      }
    };

    export const deleteEmailActionById = (quoteId) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'ALL_EMAIL' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response= await deleteEmailById(quoteId,token);
        dispatch({ type: STOP_LOADING, service: 'ALL_EMAIL' });
        dispatch({ type: DELETE_EMAIL_SUCCESS, payload: quoteId });
        return response;
      } catch (error) {
        dispatch({ type: STOP_LOADING, service: 'ALL_EMAIL' });
        dispatch({ type: DELETE_EMAIL_FAILURE, payload: error.message || 'All task service failed. Please try again.' });
      }
    };


 export const searchAction = (formData, page = 0, size = 5, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SEARCH_EMAIL' });
    const token = getState().auth.token || sessionStorage.getItem("token");

    const response = await searchCommunication(formData, token, page, size);

    dispatch({ type: STOP_LOADING, service: 'SEARCH_EMAIL' });

    if (response) {
      callbackfn?.(response);
    }

    dispatch({ type: SEARCH_EMAIL_SUCCESS, payload: response });
  } catch (error) {
    if (error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'SEARCH_EMAIL' });
      dispatch({
        type: SEARCH_EMAIL_FAILURE,
        payload: error || 'Search failed. Please try again.'
      });
    }
  }
};


    export const saveSmsAction = (formData, callbackfn) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'SAVE_SMS' });
          const token = getState().auth.token || sessionStorage.getItem("token");
          const response = await saveSMS(formData, token);
          dispatch({ type: STOP_LOADING, service: 'SAVE_SMS' });
          if (response) {
            callbackfn(response);
          }
          dispatch({ type: SAVE_SMS_SUCCESS, payload: response }); // Dispatch the success action with response data
        } catch (error) {
          if (error?.includes("403")) {
            dispatch(openSessionTimeoutModal());
          } else {
            dispatch({ type: STOP_LOADING, service: 'SAVE_SMS' });
            dispatch({ type: SAVE_SMS_FAILURE, payload: error || 'Save alert service failed. Please try again.' });
          }
        }
      };

      export const updateSmsAction = (formData,callbackfn) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'UPDATE_SMS' });
          const token = getState().auth.token || sessionStorage.getItem("token");;
          const response = await updateSMS(formData, token);
          dispatch({ type: STOP_LOADING, service: 'UPDATE_SMS' });
          if (response) {
            callbackfn(response);
          }
          dispatch({ type: UPDATE_SMS_SUCCESS, payload: response });
        } catch (error) {
          if(error?.includes("403")) {
            dispatch(openSessionTimeoutModal());
          } else {
            dispatch({ type: STOP_LOADING, service: 'UPDATE_SMS' });
            dispatch({ type: UPDATE_SMS_FAILURE, payload: error || 'Update email service failed. Please try again.' });
          }
        }
      };

      export const getAllSmsTemplatesAction = () => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: "ALL_SMS" });

          const token = getState().auth.token || sessionStorage.getItem("token");
          const response = await getAllSmsTemplates(token);

          dispatch({ type: STOP_LOADING, service: "ALL_SMS" });

          if (!response) {
            return;
          }

          dispatch({ type: GET_SMS_TEMPLATES_SUCCESS, payload: response });

        } catch (error) {
          dispatch({ type: STOP_LOADING, service: "ALL_SMS" });
          dispatch({ type: GET_SMS_TEMPLATES_FAILURE, payload: error });
        }
      };


      export const getAllSmsAction= (customer_id, page = 0, size = 5 ) => async (dispatch, getState) => {

        try {
          dispatch({ type: START_LOADING, service: 'START_LOADING' });
          const token = getState().auth.token || sessionStorage.getItem("token");
          const response = await getAllSMS(token, customer_id, page, size);
          dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
          dispatch({ type: GET_SMS_SUCCESS, payload: response });
        } catch (error) {
          dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
          dispatch({ type: GET_SMS_FAILURE, payload: error || 'All sms service failed. Please try again.' });
        }
      };

      export const deleteSmsActionById = (quoteId) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'ALL_SMS' });
          const token = getState().auth.token || sessionStorage.getItem("token");
          const response= await deleteSmsById(quoteId,token);
          dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
          dispatch({ type: DELETE_SMS_SUCCESS, payload: quoteId });
          return response;
        } catch (error) {
          dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
          dispatch({ type: DELETE_SMS_FAILURE, payload: error.message || 'All task service failed. Please try again.' });
        }
      };

      export const searchSmsAction = (formData, callbackfn) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'SEARCH_SMS' });
          const token = getState().auth.token || sessionStorage.getItem("token");
          const response = await searchSMS(formData, token);
          dispatch({ type: STOP_LOADING, service: 'SEARCH_SMS' });
          if (response) {
            callbackfn(response);
          }
          dispatch({ type: SEARCH_SMS_SUCCESS, payload: response }); // Dispatch the success action with response data
        } catch (error) {
          if (error?.includes("403")) {
            dispatch(openSessionTimeoutModal());
          } else {
            dispatch({ type: STOP_LOADING, service: 'SEARCH_SMS' });
            dispatch({ type: SEARCH_SMS_FAILURE, payload: error || 'Search note  failed. Please try again.' });
          }
        }
      };
//Phone

export const getAllPhoneAction= (page = 0, size = 5) => async (dispatch, getState) => {

    try {
      dispatch({ type: START_LOADING, service: 'ALL_PHONE' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getAllPhones(token, page, size);
      dispatch({ type: STOP_LOADING, service: 'ALL_PHONE' });
      dispatch({ type: GET_PHONE_SUCCESS, payload: response });
    } catch (error) {
      if(error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'ALL_PHONE' });
        dispatch({ type: GET_PHONE_FAILURE, payload: error || 'All task service failed. Please try again.' });
      }
    }
  };

export const searchPhoneAction = (formData, callbackfn) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'SEARCH_PHONE' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await searchPhone(formData, token);
      dispatch({ type: STOP_LOADING, service: 'SEARCH_PHONE' });
      if (response) {
        callbackfn(response);
      }
      dispatch({ type: SEARCH_PHONE_SUCCESS, payload: response }); // Dispatch the success action with response data
    } catch (error) {
      if (error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'SEARCH_PHONE' });
        dispatch({ type: SEARCH_PHONE_FAILURE, payload: error || 'Search note  failed. Please try again.' });
      }
    }
  };

export const sendMessageAction = (formData,callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SEND_MESSAGE' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await sendMessage(formData, token);

    dispatch({ type: STOP_LOADING, service: 'SEND_MESSAGE' });
    if (response) {
      callbackfn(response);
    }
    dispatch({ type: "SEND_MESSAGE_SUCCESS", payload: response }); // Dispatch the success action with response data
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'SEND_MESSAGE' });
      dispatch({ type: "SEND_MESSAGE_FAILURE", payload: error || 'Send message service failed. Please try again.' });
  }
};

export const getAllChatUserList = (page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });

    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getAllChatUserListService(token, page, size);

    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    dispatch({ type: "GET_ALL_CHAT_USER_LIST_SUCCESS", payload: response.content });

  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
    dispatch({ type: GET_SMS_FAILURE, payload: error || 'Fetching chat users failed. Please try again.' });
  }
};

export const getSelectedCustomerNumber = (phoneNumber) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    dispatch({ type: "GET_CUSTOMER_NUMBER_SUCCESS", payload: phoneNumber });
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
  }
};


export const getSelectedUserChatAction = (phonenumber, callbackfn) => async (dispatch, getState) => {

  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getSelectedUserChatService(token, phonenumber);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    if(response){
      callbackfn(response)
    }
    dispatch({ type: "GET_SELECTED_USER_CHAT_SUCCESS", payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
      dispatch({ type: "GET_SMS_FAILURE", payload: error || 'All task service failed. Please try again.' });
  }
};

export const getUserCountAction = () => async (dispatch, getState) => {

  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getUserCountService(token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    dispatch({ type: "GET_CHAT_USER_COUNT_SUCCESS", payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
      dispatch({ type: 'GET_CHAT_USER_COUNT_FAILURE', payload: error || 'All task service failed. Please try again.' });
  }
};

export const getUnreadCountAction = (unreadMessageIds) => async (dispatch, getState) => {

  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getUnreadCountService(token, unreadMessageIds);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    dispatch({ type: "UNREAD_COUNT_SUCCESS", payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
      dispatch({ type: 'UNREAD_COUNT_FAILURE', payload: error || 'All task service failed. Please try again.' });
  }
};
export const getMessageSearchAction = (messageQuery, callbackfn) => async (dispatch, getState) => {

  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getMessageSearchServices(token, messageQuery);
    if(response){
      callbackfn(response)
    }
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    dispatch({ type: "CHAT_MEESAGE_SEARCH_SUCCESS", payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
      dispatch({ type: 'CHAT_MEESAGE_SEARCH_FAILURE', payload: error || 'All task service failed. Please try again.' });
  }
};

export const getTotalMessageCountAction = () => async (dispatch, getState) => {
  try {


    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getTotalMessageCountServices(token);

    if (response) {
      dispatch({ type: "TOTAL_MEESAGE_COUNT_SUCCESS", payload: response }); // Update store first
    } else if (response === 0){
      dispatch({ type: "CLEAR_TOTAL_COUNT_SUCCESS", payload: response }); // Update store first
    }

  } catch (error) {

    dispatch({
      type: "TOTAL_MEESAGE_COUNT_FAILURE",
      payload: error || "Fetching total unread count failed. Please try again.",
    });
  }
};

export const sendEmailAction= (formData,callback) => async (dispatch, getState) => {

      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await sendEmailServices(token, formData);

        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: 'SEND_EMAIL_SUCCESS', payload: response });
        // Call the callback on success
    if (callback) callback();
      } catch (error) {
        if(error?.includes("403")) {
          dispatch(openSessionTimeoutModal());
        } else {
          dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
          dispatch({ type: "SEND_EMAIL_FAILURE", payload: error || 'All task service failed. Please try again.' });
        }
      }
    };



